import React, { FC } from "react";
import { ConnectedProps, connect } from "react-redux";
import { ComboboxProps, Label, Combobox, Option } from "@fluentui/react-components";

import { IRapComponentProperties } from "../../../../platform/Layout";
import { IUhfViewState } from "../../../../pages/Contracts";
import { UHFLocales } from "../../../../common/Constants";
import { TestActions } from "../../redux/TestActions";
import { ITestConfiguration } from "../../Contracts";
import { LabeledCombobox } from "../../../../common/components/LabeledCombobox/LabeledCombobox";
import { localizedStrings } from "../../../../common/localization/LocalizedStrings";

import * as TestSelectors from "../../redux/TestSelectors";

interface ILocaleSelectorProvidedProps extends IRapComponentProperties {
    className?: string;
}

interface ILocaleSelectorOwnProps {
    testConfig: ITestConfiguration;
}

export type ILocaleSelectorProps = ConnectedProps<typeof connector> & ILocaleSelectorProvidedProps;

const LocaleSelectorInitializer: FC<ILocaleSelectorProps> = (props) => {

    const onOptionSelect: ComboboxProps["onOptionSelect"] = (event, data) => {
        props.setTestConfig({ locale: data.optionValue });
    }

    return (
        <div className={props.className ? props.className : ""}>
            <LabeledCombobox label={localizedStrings.TestView?.TestConfigurator?.locale} onOptionSelect={onOptionSelect} value={props.testConfig?.locale}>
                {Object.values(UHFLocales).map(opt => {
                    return (
                        <Option key={opt}>
                            {opt}
                        </Option>
                    );
                })}
            </LabeledCombobox>
        </div>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: ILocaleSelectorProvidedProps): Partial<ILocaleSelectorOwnProps> {
    return {
        ...providedProps,
        testConfig: TestSelectors.getTestConfig(state)
    };
}

const ActionsToDispatch = {
    setTestConfig: TestActions.setTestConfig
};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const LocaleSelector = connector(LocaleSelectorInitializer);